import { useSelector } from 'react-redux';
import { ShoppingState } from '@/reducers/shopping';

export default function useShoppingFavoriteList() {
  const shoppingFavoriteList = useSelector(
    (state: { shopping: ShoppingState }) => state.shopping.shoppingFavoriteList
  );

  return shoppingFavoriteList;
}
